import { getNumberFromModel } from '@core/utils';

const validate = (value, [max]) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  value = getNumberFromModel(value);

  return value <= max;
};

export {
  validate
};

export default {
  validate
};
